// Semi-duplicate of `download` in `utils.tsx` - TBD which to keep
export const downloadFile = (file: Blob, filename?: string) => {
  const downloadLink = document.createElement("a");
  downloadLink.style.display = "none";
  downloadLink.href = URL.createObjectURL(file);
  downloadLink.download = filename!;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  // cleaning
  setTimeout(() => {
    URL.revokeObjectURL(downloadLink.href);
    document.body.removeChild(downloadLink);
  }, 100);
};

export async function downloadBinary(response: Response, filename: string): Promise<void> {
  const file = await response.blob();
  downloadFile(file, filename);
}
